import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';

import resource from '../resources/resource.json';

import { getCartState } from '@msdyn365-commerce/global-state';
import { SimpleProduct, AsyncResult } from '@msdyn365-commerce/retail-proxy';

import { deleteBTGPCartLineAsync, getAllBTGPCartLineAsync } from '../../../actions/DataActionExtension.g';

import { IField, IdState } from '../ecomm-product-details-form.data';
import { IEcommProductDetailsFormConfig } from '../ecomm-product-details-form.props.autogenerated';

interface IEcommFormProps {
  formScheme: IField[];
  selectedProduct: AsyncResult<SimpleProduct>;
  rowsData: IdState[];
  addRow(noOfRows: Number): void;
  deleteRow(idx: number): void;
  callbackEvent?: any;
  callbackEventID?: any;
  callbackName?: any;
  callbackCategory?: any;
  callbackNamesEntered?: any;
  formItems: [];
  config: IEcommProductDetailsFormConfig;
  localeCode: string;
  actionContext: any;
  isMobile: boolean;
  isEditMode: boolean;
  productEvents: any[];
  allowMultipleRegistrations: boolean;
}

const CategoryNamesForm: React.FC<IEcommFormProps> = ({ formScheme, selectedProduct, rowsData, addRow, deleteRow, callbackEvent, callbackEventID, callbackName, callbackCategory, callbackNamesEntered, formItems, config, localeCode, actionContext, isMobile, isEditMode, productEvents, allowMultipleRegistrations }) => {
  const [radioValue, setRadioValue] = useState([resource.categoryFamilyLabel[`${localeCode}`]]);
  const [ceremonyValue, setCeremonyValue] = useState(['']);
  const [ceremonyIDValue, setCeremonyIDValue] = useState(['']);
  const [ceremonyName, setCeremonyName] = useState(['']);

  const formLabels = resource.categoryNamesForm[`${localeCode}`];

  const noOfNames = formScheme.find(form => form.field_type === 'textBox')!.field_number!;
  const companyNames = formScheme.find(form => form.field_type === 'textBox')!.field_number2!;

  const onSubmit = (data: any) => {
    // display form data on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(data, null, 4));
  };

  // Functions to build form returned by useForm() hook.
  const { handleSubmit, reset } = useForm();

  const _onChangeRadioValue = (event: any, index: number) => {
    _setRadioValueArray(event.target.value, index);

    let ceremonyNameArray = ceremonyName.slice();
    let existingCeremonyName = ceremonyNameArray[`${index}`];
    if (existingCeremonyName) {
      let existingNameArray = existingCeremonyName.split(';');

      if (event.target.value === resource.categoryFamilyLabel[`${localeCode}`]) {
        if (existingNameArray.length < noOfNames) {
          existingCeremonyName += ';'.repeat(noOfNames - existingNameArray.length - 1);
        } else { // More than
          while (existingNameArray.length > noOfNames) {
            existingNameArray.pop();
          }
          existingCeremonyName = existingNameArray.join(';');
        }
      } else {
        if (existingNameArray.length < companyNames) {
          existingCeremonyName += ';'.repeat(companyNames - existingNameArray.length - 1);
        } else { // More than
          while (existingNameArray.length > companyNames) {
            existingNameArray.pop();
          }
          existingCeremonyName = existingNameArray.join(';');
        }
      }
    }
    ceremonyNameArray[`${index}`] = existingCeremonyName;

    setCeremonyName(ceremonyNameArray);

    callbackName(ceremonyNameArray);
  };

  const _setRadioValueArray = (value: string, index: number) => {
    let radioValueArray = radioValue.slice();

    while (typeof radioValueArray[`${index}`] === 'undefined') {
      radioValueArray.push(resource.categoryFamilyLabel[`${localeCode}`]);
    }

    radioValueArray[`${index}`] = value;

    setRadioValue(radioValueArray);

    callbackCategory(radioValueArray);
  };

  const _displayName = (value: string, nameIndex: number): string => {
    if (value) {
      const names = value.split(';');

      return names[`${nameIndex}`] ? names[`${nameIndex}`] : '';
    }

    return ''
  }

  const _setNameMultipleInputValue = (event: any, index: number, nameIndex: number, noOfNames: number) => {
    const maxLength = config.charactersLimitForNames ? config.charactersLimitForNames : 31;

    let inputName = event.target.value.substring(0, maxLength - 1);

    let inputMultipleName = ceremonyName[`${index}`];
    
    if (inputMultipleName) {
      if (!inputMultipleName.includes(';')) {
        inputMultipleName += ';'.repeat(noOfNames - 1);
      }

      const inputMutlipleNameSplit = inputMultipleName.split(';');

      inputMutlipleNameSplit[`${nameIndex}`] = inputName;
      inputName = inputMutlipleNameSplit.join(';');
    }
    
    _setCeremonyNameArray(inputName, index);
  }

  const _setCeremonyNameArray = (name: string, index: number) => {
    const ceremonyNameArray = ceremonyName.slice();

    while (typeof ceremonyNameArray[`${index}`] === 'undefined') {
      ceremonyNameArray.push('');
    }

    ceremonyNameArray[`${index}`] = name;

    ceremonyNameArray[`${index}`].trim();

    setCeremonyName(ceremonyNameArray);

    callbackName(ceremonyNameArray);

    _checkNamesEntered(ceremonyNameArray);
  }

  const _checkNamesEntered = (ceremonyNameArray: string[]) => {
    let namesEntered = true;

    for (let i = 0; i < ceremonyNameArray.length; i++) {
      if (ceremonyNameArray[`${i}`].replace(/;/g, '').trim() === '') {
        namesEntered = false;
        break;
      }
    }

    callbackNamesEntered(namesEntered);
  }

  const _addItem = () => {
    addRow(1);

    const categoryValueArray = radioValue.slice();
    const ceremonyValueArray = ceremonyValue.slice();
    const ceremonyIDValueArray = ceremonyIDValue.slice();
    const ceremonyNameArray = ceremonyName.slice();

    categoryValueArray.push(resource.categoryFamilyLabel[`${localeCode}`]);
    ceremonyValueArray.push(productEvents && productEvents.length > 0 ? productEvents[0]['name'] : '');
    ceremonyIDValueArray.push(productEvents && productEvents.length > 0 ? productEvents[0]['id'] : '');
    ceremonyNameArray.push('');

    setRadioValue(categoryValueArray);
    setCeremonyValue(ceremonyValueArray);
    setCeremonyIDValue(ceremonyIDValueArray);
    setCeremonyName(ceremonyNameArray);

    callbackCategory(categoryValueArray);
    callbackEvent(ceremonyValueArray);
    callbackEventID(ceremonyIDValueArray);
    callbackName(ceremonyNameArray);

    callbackNamesEntered(false);
  }

  const _deleteCartLine = async (index: number): Promise<void> => {
    if (typeof formItems[`${index}`] !== 'undefined') {
      const cartState = await getCartState(actionContext);

      let success = false;

      const cartItems = await getAllBTGPCartLineAsync({ callerContext: actionContext }, cartState.cart.Id);

      if (cartItems.length > 0) {
        let removeCartLinesResult = await cartState.removeCartLines({ cartLineIds: [formItems[`${index}`]['cartLineId']] });

        if (removeCartLinesResult.status === 'SUCCESS') {
          success = true;
        }

        let deleteCartLineResult = await deleteBTGPCartLineAsync({ callerContext: actionContext }, formItems[`${index}`]['cartLineId']);

        if (success && deleteCartLineResult) {
          deleteRow(index);
          formItems.splice(index, 1);
          _updateStateData(index);
        }

      } else {
        deleteRow(index);
        _updateStateData(index);
      }
    } else {
      deleteRow(index);
      _updateStateData(index);
    }
  }

  const _updateStateData = (index: number) => {
    const categoryValueArray = radioValue.slice();
    const ceremonyValueArray = ceremonyValue.slice();
    const ceremonyIDValueArray = ceremonyIDValue.slice();
    const ceremonyNameArray = ceremonyName.slice();

    if (typeof categoryValueArray[`${index}`] !== 'undefined') {
      if (categoryValueArray.length > 1) {
        categoryValueArray.splice(index, 1);
      } else {
        categoryValueArray[0] = resource.categoryFamilyLabel[`${localeCode}`];
      }
    }

    if (typeof ceremonyValueArray[`${index}`] !== 'undefined') {
      if (ceremonyValueArray.length > 1) {
        ceremonyValueArray.splice(index, 1);
      } else {
        ceremonyValueArray[0] = productEvents && productEvents.length > 0 ? productEvents[0]['name'] : '';
      }
    }

    if (typeof ceremonyIDValueArray[`${index}`] !== 'undefined') {
      if (ceremonyIDValueArray.length > 1) {
        ceremonyIDValueArray.splice(index, 1);
      } else {
        ceremonyIDValueArray[0] = productEvents && productEvents.length > 0 ? productEvents[0]['id'] : '';
      }
    }

    if (typeof ceremonyNameArray[`${index}`] !== 'undefined') {
      if (ceremonyNameArray.length > 1) {
        ceremonyNameArray.splice(index, 1);
      } else {
        ceremonyNameArray[0] = '';
      }
    }

    setRadioValue(categoryValueArray);
    setCeremonyValue(ceremonyValueArray);
    setCeremonyIDValue(ceremonyIDValueArray);
    setCeremonyName(ceremonyNameArray);

    callbackCategory(categoryValueArray);
    callbackEvent(ceremonyValueArray);
    callbackEventID(ceremonyIDValueArray);
    callbackName(ceremonyNameArray);

    _checkNamesEntered(ceremonyNameArray);
  }

  useEffect(() => {
    const existingRadioValue: string[] = [];
    const existingCeremony: string[] = [];
    const existingCeremonyID: string[] = [];
    const existingCeremonyName: string[] = [];

    if (formItems.length > 0) {
      for (let i = 0; i < formItems.length; i++) {
        const itemNames: string[] = formItems[`${i}`]['names'];
        const itemCategory = formItems[`${i}`]['category'];

        let itemNameCount = noOfNames;

        if (itemCategory !== resource.categoryFamilyLabel[`${localeCode}`]) {
          itemNameCount = companyNames;
        }

        let itemName = '';

        itemNames.map((name, index) => {
          if (index !== 0 && index < itemNameCount) {
            itemName += ';' + name;
          } else {
            itemName += name;
          }
        });

        existingCeremony.push(productEvents && productEvents.length > 0 ? productEvents[0]['name'] : '');
        existingCeremonyID.push(productEvents && productEvents.length > 0 ? productEvents[0]['id'] : '');
        existingRadioValue.push(itemCategory);
        existingCeremonyName.push(itemName);
      }

      setCeremonyName(existingCeremonyName);

      callbackName(existingCeremonyName);

      _checkNamesEntered(existingCeremonyName);
    } else {
      existingCeremony.push(productEvents && productEvents.length > 0 ? productEvents[0]['name'] : '');
      existingCeremonyID.push(productEvents && productEvents.length > 0 ? productEvents[0]['id'] : '');
      existingRadioValue.push(resource.categoryFamilyLabel[`${localeCode}`]);
    }

    setCeremonyValue(existingCeremony);
    setCeremonyIDValue(existingCeremonyID);
    setRadioValue(existingRadioValue);

    callbackCategory(existingRadioValue);
    callbackEvent(existingCeremony);
    callbackEventID(existingCeremonyID);
  }, [formItems]);

  const _buildCategoryField = (idx: number): JSX.Element | null => {
    if (typeof radioValue[`${idx}`] === 'undefined') {
      return null;
    }

    return (
      <div className='row'>
        <div className='col-12'>
          <p className='form-label'>{formLabels.category}</p>
          <div className='form-field row'>
            <label className='radio-option col-12 col-lg-3'>
              <input
                type='radio'
                value={resource.categoryFamilyLabel[`${localeCode}`]}
                checked={radioValue[`${idx}`] === String(resource.categoryFamilyLabel[`${localeCode}`])}
                aria-checked={radioValue[`${idx}`] === String(resource.categoryFamilyLabel[`${localeCode}`])}
                onChange={(event) => _onChangeRadioValue(event, idx)}
              />
              {resource.categoryFamilyLabel[`${localeCode}`]}
            </label>

            <label className='radio-option col-12 col-lg-3'>
              <input
                type='radio'
                value={resource.categoryCompanyLabel[`${localeCode}`]}
                checked={radioValue[`${idx}`] === String(resource.categoryCompanyLabel[`${localeCode}`])}
                aria-checked={radioValue[`${idx}`] === String(resource.categoryCompanyLabel[`${localeCode}`])}
                onChange={(event) => _onChangeRadioValue(event, idx)}
              />
              {resource.categoryCompanyLabel[`${localeCode}`]}
            </label>
          </div>
        </div>
      </div>
    )
  }

  const _buildNameGroup = (idx: number, noOfNames: number): JSX.Element[] => {
    const nameLabel = formLabels.name;
    const namesArray = Array.apply(null, Array(noOfNames)).map(function (x, i) { return i; });

    return namesArray.map(nameIndex => {
      return (
        <div className='row'>
          <div className='col-lg-6 form-field'>
            <p className='form-label'>{nameLabel.endsWith('*') ? nameIndex === 0 ? nameLabel.substring(0, nameLabel.length - 1) + ' ' + (nameIndex + 1) + '*' : nameLabel.replace('*', ' ' + (nameIndex + 1)) : nameLabel + ' ' + nameIndex + 1}</p>
            <input
              type='text'
              inputMode='text'
              value={_displayName(ceremonyName[`${idx}`], nameIndex)}
              aria-live='polite'
              role='spinbutton'
              onChange={(event: any) => _setNameMultipleInputValue(event, idx, nameIndex, noOfNames)}
              onKeyDown={event => { if (event.keyCode === 13) { event.preventDefault(); } }}
              className='form-control'
              maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
            />
          </div>
        </div>
      );
    });
  }

  return (
    <div className='ecomm-purchase-form'>
      <form onSubmit={handleSubmit(onSubmit)} onReset={reset} autoComplete='off'>
        <div className='ecomm-purchase-form-table'>
          {rowsData.map((i, idx) => {
            return (
              <div className='form-record'>
                <div key={`row${i.id}`} className='form-details row'>
                  {formScheme.map((element: IField, index: number) => {

                    if (element.field_name === 'category') {
                      return (
                        <div className='form-details-item col-lg-9'>
                          {_buildCategoryField(idx)}
                          {radioValue[`${idx}`] === String(resource.categoryFamilyLabel[`${localeCode}`]) && noOfNames > 0 && _buildNameGroup(idx, noOfNames)}
                          {radioValue[`${idx}`] === String(resource.categoryCompanyLabel[`${localeCode}`]) && companyNames > 0 && _buildNameGroup(idx, companyNames)}
                        </div>
                      );
                    }

                    if (!isMobile && element.field_type === 'product_price') {
                      return (
                        <div className='form-details-item bordered centred col-2'>
                          <p key={index} className='subtotal'>${selectedProduct.result?.Price!}</p>
                        </div>
                      );
                    }

                    if (element.field_type === 'action') {
                      if (isMobile) {
                        const style = !isEditMode ? 'form-details-item' : 'form-details-item edit';

                        return (
                          <div className={style}>
                            {!isEditMode && allowMultipleRegistrations && <div className='col-10'>
                              <button className='add-row' type='submit' onClick={_addItem}>{resource.addAnotherItemTitle[`${localeCode}`]}</button>
                            </div>}
                            <div className='delete-wrapper col-2'><button className={element.action} onClick={() => _deleteCartLine(idx)} /></div>
                          </div>
                        );
                      }

                      return (
                        <div className='form-details-item centred col-sm-1'>
                          <button className={element.action} onClick={() => _deleteCartLine(idx)} />
                        </div>
                      );
                    }

                    return;
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {!isMobile && !isEditMode && allowMultipleRegistrations &&
          <div className='ecomm-purchase-form-add'>
            <button type='submit' onClick={_addItem}>{resource.addAnotherItemTitle[`${localeCode}`]}</button>
          </div>
        }
      </form>
    </div>
  );
};

export default CategoryNamesForm;